"use client";

import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { useLogout } from "@/features/auth/hooks/use-logout";
import { appendInvitationToken } from "@/lib/invitation-links";

interface WrongAccountProps {
  invitationToken: string;
  invitedEmail: string;
  signedInEmail: string;
}

export function WrongAccount({
  invitationToken,
  invitedEmail,
  signedInEmail,
}: WrongAccountProps) {
  const router = useRouter();
  const logout = useLogout();
  const invitationLoginPath = appendInvitationToken("/login", invitationToken);

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-contrast/70 leading-5">
        This invite was sent to{" "}
        <span className="text-heading font-medium">{invitedEmail}</span>, but
        you&apos;re signed in as{" "}
        <span className="text-heading font-medium">{signedInEmail}</span>.
      </p>
      <p className="text-sm text-contrast/50 leading-5">
        Sign out to continue with the invited account, or return to your current
        workspace.
      </p>
      <div className="flex flex-col gap-2">
        <Button
          type="button"
          variant="light"
          size="auth"
          onClick={() => logout.mutate({ returnTo: invitationLoginPath })}
          disabled={logout.isPending}
        >
          {logout.isPending ? "Signing out..." : "Sign out and continue"}
        </Button>
        <button
          onClick={() => router.push("/projects")}
          className="text-sm text-contrast/40 hover:text-contrast/60 transition-colors cursor-pointer text-center"
        >
          Return to your workspace
        </button>
      </div>
    </div>
  );
}
